module.exports = __webpack_public_path__ + "img/default_manager.6a7613ed.png";